import React, { useEffect } from "react";
import { Page } from "../types/Page";
import { Button, OverlayTrigger, Table, Popover } from "react-bootstrap";
import "../styles/EmployeeList.css";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { Edit, Trash } from "react-feather";
import { AppDispatch } from "../redux/store";
import { fetchPages } from "../redux/actions/pageAction";
import { fetchSubModules } from "../redux/actions/subModuleAction";

interface Props {
  pages: Page[];
  onEdit: (page: Page) => void;
  onDelete: (id: number) => void;
}

const PageList: React.FC<Props> = ({ pages, onEdit, onDelete }) => {
  const dispatch = useDispatch<AppDispatch>();

  const editPopover = (
    <Popover id="popover-edit">
      <Popover.Body>Edit details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-delete">
      <Popover.Body>Delete details</Popover.Body>
    </Popover>
  );
  const subModules = useSelector((state: StoreState) => state.subModule);

  useEffect(() => {
    dispatch(fetchPages());
  }, []);

  useEffect(() => {
    dispatch(fetchSubModules());
  }, []);

  return (
    <Table className="custom-employee-table" responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Sub Module</th>
          <th>Name</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {pages.map((pg, index) => {
          const subModule = subModules.find(
            (p) => Number(p.id) === Number(pg.subModuleId),
          );
          const subModuleName = subModule?.name;

          return (
            <tr key={pg.id}>
              <td>{index + 1}</td>
              <td>{subModuleName}</td>
              <td>{pg.name}</td>
              <td className="d-flex no-wrap border-0 justify-content-center">
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={editPopover}
                >
                  <Button
                    variant="warning"
                    className="mr-2"
                    onClick={() => onEdit(pg)}
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                  >
                    <Edit />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={deletePopover}
                >
                  <Button
                    variant="danger"
                    onClick={() => onDelete(pg.id)}
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                  >
                    <Trash />
                  </Button>
                </OverlayTrigger>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default PageList;
